// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"_spinner_spinnerContainer__worlO","spinner":"_spinner_spinner__FCpIm","rotate":"_spinner_rotate__GMUK0"};